// generated on build time, from script >> scripts/build-environment-conf.sh

export const environment = {
  production: true,
  env: 'dev',
  baseUrl: 'https://api.dev.belender.net',
  cdnImgBaseUrl: 'https://widget.dev.belender.net/assets/img/',
  scraperMock: false,
  notificationsBaseUrl: 'wss://notifications.dev.belender.net',
  isWebComponent: false // 👇 Variable para el modo SPA o web-component
};


